import {
  getRequest,
  postRequest,
  putRequest,
  delRequest,
} from '@/utils/request';
// 创建博主名片
export const createBusinessCards = (data: any) =>
  postRequest('/influencer/business-cards/create', data);
// 更新博主名片
export const updateBusinessCards = (data: any) =>
  putRequest('/influencer/business-cards/update', data);
// 删除博主名片
export const deleteBusinessCards = (id: string) =>
  delRequest(`/influencer/business-cards/delete?id=${id}`);
// 获得博主名片
export const getBusinessCards = (data: any) =>
  getRequest('/influencer/business-cards/get', data);
// 获得博主名片分页
export const getBusinessCardsPage = (data: any) => {
  return getRequest('/influencer/business-cards/my-cards', data);
};
// 导出博主名片 Excel
export const exportBusinessCardsPage = (data: any) =>
  getRequest('/influencer/business-cards/export-excel', data);
// 获得我的名片列表
export const getBusinessMyCards = (data: any) =>
  getRequest('/influencer/business-cards/my-cards', data);
// 获得平台列表
export const getPlatformsList = (data?: any, opts = {}) =>
  getRequest('/advertiser/platforms/list', data, opts);
// 获得领域（标签）列表，见 /advertiser/fields/list（lang：ZH | EN | ES）
export const getDomainTags = (params?: { lang?: string }, opts = {}) =>
  getRequest('/advertiser/fields/list', params ?? {}, opts);
// 检查博主是否为会员
export const checkUserMemberships = (data?: any) =>
  getRequest('/influencer/user-memberships/check', data);
// 获取我的默认名片
export const getDefaultBusinessCards = (data?: any) =>
  getRequest('/influencer/business-cards/my-default', data);
